import { sanitizeRedirectPath } from "@/lib/auth/redirect";

/** Route that starts Kakao Login (server-side state/PKCE/nonce cookie). */
export const KAKAO_SIGN_IN_PATH = "/api/auth/kakao";

/**
 * Link that starts Kakao sign-in and returns to `redirectPath` afterwards.
 * The path is sanitized and URL-encoded (it is validated again on the server).
 */
export function buildKakaoSignInHref(redirectPath: unknown): string {
  const params = new URLSearchParams({
    redirectPath: sanitizeRedirectPath(redirectPath),
  });

  return `${KAKAO_SIGN_IN_PATH}?${params.toString()}`;
}
